import styled from 'styled-components';
import {colorTheme} from '../../../mixin/colorTheme';

export const FormGroup = styled.div`
    --radius-form-control: var(--space-xsm);
    --height-form-control: 36px;
    --padding-form-control-horz: var(--space);
    --padding-form-control: 0 var(--padding-form-control-horz);
    ${colorTheme({
        // === input type file ===
        // -----------------------
        '--form-upload-file-btn-background      ': {dark: 'var(--blue-08)  ', light: 'var(--blue-08)'},
        '--form-upload-file-btn-background-hover': {dark: 'var(--blue-09)  ', light: 'var(--blue-09)'},
        '--form-upload-file-btn-text            ': {dark: 'var(--white-00) ', light: 'var(--white-00)'},
        '--upload-file-text                     ': {dark: ' var(--gray-07)', light: ' var(--gray-07)'},

        // === Async dropdown select ===
        // -----------------------
        '--select-clear-indicator       ': {dark: ' var(--danger)             ', light: ' var(--danger)'},
        '--select-clear-indicator-hover ': {dark: ' var(--red-06)             ', light: ' var(--danger-dark)'},
    })};

    margin-bottom: var(--space-md);
    width: 100%;
    font-size: var(--text-size-default);
    font-weight: 600;
    text-align: left;

    ${({formDetail}) => {
        if (formDetail === true)
            return `
        margin-bottom: var(--space-sm);
        `;
        else return '';
    }}
`;
